import { h } from 'preact';

import { Trans } from '@lingui/macro';

export const Menu = () => (
	<a href={'#/notes'}><Trans>Notes</Trans></a>
);
